<script>
import FavoriteTool from '../lib/favorite-tool.vue'
import VisitsTool from './visits-tool.vue'

export default {
    emits: ['search', 'delete-search'],
    components: {FavoriteTool, VisitsTool},
    props: {
        favKey: {type: String, required: true},
        favMode: {type: Boolean, required: true},
        filter: {type: Object, required: true},
        visitsActive: {type: Boolean, default: false},
        numVisits: {type: Number, default: 0},
    },
    data() {
        return {
            search: this.filter.search,
        }
    },

    computed: {
        favActive() { return this.filter.favorites },
    },

    methods: {
        rangeAtoZ() {
            let range = ['#']
            for (var i = 'A'.charCodeAt(0); i <= 'Z'.charCodeAt(0); i++) {
                range.push(String.fromCharCode(i));
            }
            return range
        },
        onSearchInput() {
            if (this.search === '') this.$emit('delete-search')
        },

        filterActive: function(letter) {
           return this.filter.company__name__gt == letter
        },
        toggleVisits() {
            this.$emit('toggle-visits', !this.visitsActive)
        }
    },
}
</script>

<template>
<div>
    <nav class="navbar navbar-expand-lg justify-content-between bg-info px-3">
        <favorite-tool v-if="!favMode" :active="favActive" @click="$emit('toggle-favorites', !favActive)" />
        <visits-tool v-if="!favMode" :active="visitsActive" @click="toggleVisits()" />

        <button class="btn btn-sm navbar-btn btn-secondary me-1 mb-1"
        v-b-tooltip.hover title="Export List" @click.prevent="$emit('export-list')">
            <i class="fas fa-download"></i>
        </button>

        <div class="ml-auto">
            <form class="form-inline">
                <div class="d-flex flex-nowrap">
                <input class="form-control me-sm-2" type="search" placeholder="Quick Search" v-model="search"
                v-on:keyup.enter="$emit('search', search)" @input="onSearchInput()">
                <button class="btn btn-secondary" @click.prevent="$emit('search', search)">
                    <span class="fa fa-search"></span>
                </button>
                </div>
            </form>
        </div>
    </nav>
    <div class="d-flex flex-row flex-nowrap justify-content-around py-3">
        <b class="c-letter" v-for="letter in rangeAtoZ()" :key="letter"
         :class="{'c-underscore': filterActive(letter)}"
         @click="$emit('on-filter-value', letter)">{{ letter }}</b>
    </div>
</div>
</template>

<style scoped>
.nav-link {
    text-decoration: none;
}
.c-underscore {
    text-decoration: underline;
}

.c-letter {
    cursor: pointer;
}
</style>